import setPath from '@/lib/setPath';
import setQuery from '@/lib/setQuery';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { query } from '@/redux/selectors/querySelectors';
import selectors from '@/redux/selectors/selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const blacklistedDomElements = ['.confirm-dialog'];

const EscapeKeyHandler = () => {
  const mapperTab = useArgSelector(query, 'mapperTab');
  const editMapper = useArgSelector(query, 'editMapper');
  const mapperKey = useArgSelector(query, 'mapperKey');
  const editResponseMapper = useArgSelector(query, 'editResponseMapper');
  const requestMapperId = useArgSelector(query, 'requestMapperId');
  const responseMapperId = useArgSelector(query, 'responseMapperId');

  const hasOpenModal = useSelector(selectors.hasOpenModal);

  const escapePaths = [
    { startPath: /^\/credentials\/[^\/]+$/, endPath: `/credentials` } // eslint-disable-line
  ];

  const handleEscapeKeyDown = (e) => {
    if (e.keyCode === 27) {
      if (hasOpenModal || mapperTab) {
        return;
      }

      const activeElement = document.activeElement;

      const matchedBlacklist = blacklistedDomElements.find((n) => !![...document.querySelectorAll(n)].length);
      if (matchedBlacklist) {
        return;
      }

      const ignoreEscapeKeyHandler = activeElement.getAttribute('data-ignore-escape-key-handler');
      if (String(ignoreEscapeKeyHandler) === 'true') {
        return;
      }

      if (activeElement && ['SELECT'].includes(activeElement.nodeName)) {
        return activeElement.blur();
      }

      if (activeElement && ['INPUT', 'TEXTAREA'].includes(activeElement.nodeName)) {
        if (activeElement.innerHTML !== '') {
          return activeElement.blur();
        }
      }

      if (editMapper) {
        setQuery({ editMapper: undefined });
        return;
      }
      if (mapperKey) {
        setQuery({ mapperKey: undefined });
        return;
      }
      if (editResponseMapper) {
        setQuery({ editResponseMapper: undefined });
        return;
      }
      if (requestMapperId) {
        setQuery({ requestMapperId: undefined });
        return;
      }
      if (responseMapperId) {
        setQuery({ responseMapperId: undefined });
        return;
      }

      for (let i = 0; i < escapePaths.length; i++) {
        if (escapePaths[i].startPath.test(window.location.pathname)) {
          setPath(escapePaths[i].endPath);
          return;
        }
      }
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleEscapeKeyDown);
    return () => document.removeEventListener('keydown', handleEscapeKeyDown);
  }, [hasOpenModal, mapperTab, editMapper, mapperKey, editResponseMapper, requestMapperId, responseMapperId]);

  return null;
};

export default EscapeKeyHandler;
